// assets/product-form.js

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        const giftBoxNote = this.querySelector('#product-giftwrap-message');
        const hiddenGiftMessageInput = this.querySelector('.product-variant-message');
        const finalMessageInput = this.querySelector('.product-final_message');
        const giftMessageInput = this.querySelector('input.product-variant-message');
        const engravingInputPrompt = this.querySelector('input.product-eng_prompt');
        const referenceInputPrompt = this.querySelector('input.product-reference');
        const singleSideInput = this.querySelector('input.product-single_side');
        const doubleSideInput = this.querySelector('input.product-double_side');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
    
       async  detectAndHandleExtras() {
          try {
            const form = this.form;
            const prodcutReference = form.querySelector('.product-reference');
            const oneSide = form.querySelector('.product-single_side');
            const twoSides = form.querySelector('.product-double_side');
            const gift = form.querySelector('.product-variant-message');

            // More precise “has” flags
            const hasReference = prodcutReference && !prodcutReference.disabled;
            
            // IMPROVED: Check engraving state - prioritize enabled input over disabled
            // If both have values, prefer the one that's enabled
            // If double-side is enabled, it takes precedence (includes both sides)
            let hasOne = false;
            let hasTwo = false;
            
            if (oneSide) {
              // Check if input has value AND is enabled
              hasOne = !oneSide.disabled && oneSide.value && oneSide.value.trim() !== '';
              // Also check if it has a valid price value (not just empty)
              if (hasOne) {
                const valueMatch = oneSide.value.match(/[\$]?([0-9]+)/);
                hasOne = valueMatch && parseInt(valueMatch[1]) > 0;
              }
            }
            
            if (twoSides) {
              // Check if input has value AND is enabled
              hasTwo = !twoSides.disabled && twoSides.value && twoSides.value.trim() !== '';
              // Also check if it has a valid price value
              if (hasTwo) {
                const valueMatch = twoSides.value.match(/[\$]?([0-9]+)/);
                hasTwo = valueMatch && parseInt(valueMatch[1]) > 0;
              }
            }
            
            // If both are enabled with values, prefer double-side (it includes both)
            if (hasOne && hasTwo) {
              console.log('Both engraving inputs have values - preferring double-side');
              hasOne = false; // Clear single-side if both present
            }
            
            console.log('Engraving detection:', { hasOne, hasTwo, oneSideValue: oneSide?.value, twoSidesValue: twoSides?.value, oneSideDisabled: oneSide?.disabled, twoSidesDisabled: twoSides?.disabled });

            // Check dropdown first to determine if gift is actually selected
            const giftwrapSelect = document.getElementById('product-giftwrap-options');
            const selectedGiftOption = giftwrapSelect?.value;
            
            // IMPORTANT: If dropdown value is "0" or empty, user selected "No" - no gift should be added
            const isGiftSelected = selectedGiftOption && selectedGiftOption !== '' && selectedGiftOption !== '0';
            
            // For gift: require that user actually selected a gift option (value not empty/zero)
            // Also check that dropdown doesn't have "0" selected
            const hasGift = isGiftSelected && gift && !gift.disabled && gift.value && gift.value !== '' && gift.value !== '0';

            // Get reference ID from form - this uniquely identifies this main product instance
            // NOTE: This should already be set by onSubmitHandler before detectAndHandleExtras is called
            let reference = prodcutReference?.value || '';
            
            // Fallback safety: If reference is still empty, generate one
            // This should rarely happen as onSubmitHandler sets it, but safety check
            if (!reference || reference.trim() === '') {
              // Generate unique reference: timestamp + random number
              reference = `ref_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
              console.warn('Reference was empty in detectAndHandleExtras, generated new one:', reference);
              // Update the input field for form submission
              if (prodcutReference) {
                prodcutReference.value = reference;
              }
            }
            
            console.log('Using reference ID for addon linking:', reference);
            
            // More robust price parsing - try multiple formats
            let giftPrice = null;
            if (hasGift && gift.value) {
              const giftValue = gift.value.trim();
              console.log('Gift input value:', giftValue);
              
              // Try to match price in parentheses: ($25), ($0), etc.
              let match = giftValue.match(/\(([^)]+)\)/);
              if (match) {
                let priceText = match[1].replace(/[^0-9.]/g, '');
                if (priceText) {
                  giftPrice = parseFloat(priceText);
                  console.log('Parsed price from parentheses:', giftPrice);
                }
              }
              
              // If no match, try to extract any number from the value
              if (giftPrice === null || isNaN(giftPrice)) {
                const numberMatch = giftValue.match(/(\d+\.?\d*)/);
                if (numberMatch) {
                  giftPrice = parseFloat(numberMatch[1]);
                  console.log('Parsed price from number match:', giftPrice);
                }
              }
              
              // If still no price, try to get it from the gift wrap select dropdown
              if ((giftPrice === null || isNaN(giftPrice)) && giftValue && isGiftSelected) {
                if (giftwrapSelect && giftwrapSelect.value && giftwrapSelect.value !== '0') {
                  const selectedOption = giftwrapSelect.selectedOptions[0];
                  if (selectedOption) {
                    const dataPrice = selectedOption.getAttribute('data-price');
                    if (dataPrice && dataPrice !== 'nill') {
                      giftPrice = parseFloat(dataPrice) || 0;
                      console.log('Parsed price from dropdown data-price:', giftPrice);
                      // Update the gift input value to match expected format
                      gift.value = `($${giftPrice})`;
                    }
                  }
                }
              }
            }

            const giftBoxNote = document.querySelector('#product-giftwrap-message');

            // CRITICAL CHECK: If dropdown is "0" (No gift), don't proceed with addon
            if (!isGiftSelected || selectedGiftOption === '0') {
              console.log('No gift selected (option 0) - skipping gift addon');
              // Don't set hasGift to true, continue to check engraving only
            }

            // If gift is selected but the price couldn't be parsed, bail
            if (hasGift && (giftPrice === null || isNaN(giftPrice))) {
              console.warn("Gift detected but price couldn't be parsed—skipping addon");
              console.warn("Gift input details:", {
                value: gift?.value,
                disabled: gift?.disabled,
                name: gift?.name,
                giftwrapSelect: giftwrapSelect?.value,
                isGiftSelected: isGiftSelected
              });
              return { description: 'Gift selected but price invalid', variant: null };
            }
            
            // Ensure giftPrice is a number (default to 0 if null)
            // Only set to 0 if we actually have a gift selected
            if (hasGift && (giftPrice === null || isNaN(giftPrice))) {
              giftPrice = 0;
            }

            // If note field exists and a gift is expected, but note is empty / whitespace => show error
            // Exception: Option 1 (free complimentary message) doesn't require a message
            if (hasGift && giftBoxNote && giftPrice !== 0) {
              const message = giftBoxNote.value.trim();
              if (message === '') {
                const errDiv = document.createElement('div');
                errDiv.className = 'error_message';
                errDiv.textContent = 'Please enter your gift message or choose a different option for gift wrap.';
                errDiv.style.color = 'red';
                errDiv.style.fontSize = '12px';
                errDiv.style.marginTop = '4px';
                // Remove existing error if any
                const existingError = giftBoxNote.parentElement.querySelector('.error_message');
                if (existingError) existingError.remove();
                giftBoxNote.insertAdjacentElement('afterend', errDiv);
                errDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
                setTimeout(() => {
                  if (errDiv.parentNode) {
                    errDiv.parentNode.removeChild(errDiv);
                  }
                }, 5000);
                return { description: 'Gift message required', variant: null };
              }
            }

            // Determine engraving state
            // IMPORTANT: Double-side takes precedence if both are enabled
            let engraving = 'none';
            if (hasTwo) {
              engraving = 'twoSides';
              console.log('Detected: Two-side engraving');
            } else if (hasOne) {
              engraving = 'oneSide';
              console.log('Detected: One-side engraving');
            } else {
              console.log('Detected: No engraving');
            }

            // Build description
            let description = '';
            if (!hasGift && engraving === 'none') {
              description = 'No extras selected';
            } else if (!hasGift && engraving === 'oneSide') {
              description = 'One‑Side Engraving only';
            } else if (!hasGift && engraving === 'twoSides') {
              description = 'Two‑Sides Engraving only';
            } else if (hasGift && giftPrice === 0 && engraving === 'none') {
              description = 'Free gift wrap only';
            } else if (hasGift && giftPrice === 0 && engraving === 'oneSide') {
              description = 'One‑Side Engraving + Free Gift Wrap';
            } else if (hasGift && giftPrice === 0 && engraving === 'twoSides') {
              description = 'Two‑Sides Engraving + Free Gift Wrap';
            } else if (hasGift && giftPrice === 25) {
              description = engraving === 'none'
                ? 'Variant 1 (Paid Gift Wrap)'
                : engraving === 'oneSide'
                  ? 'Variant 2 (One‑Side + Paid Wrap)'
                  : 'Variant 3 (Two‑Sides + Paid Wrap)';
            } else if (hasGift && giftPrice === 50) {
              description = engraving === 'none'
                ? 'Variant 4 (Higher‑Cost Wrap)'
                : engraving === 'oneSide'
                  ? 'Variant 5 (One‑Side + Higher‑Cost Wrap)'
                  : 'Variant 6 (Two‑Sides + Higher‑Cost Wrap)';
            } else {
              description = 'Unknown variant';
            }

            console.log('Determined description:', description);
            console.log('Gift state:', { hasGift, giftPrice, engraving });

            // Get extras variants JSON
            const extrasJsonEl = document.getElementById('extras-variants-json');
            const extrasData = extrasJsonEl ? JSON.parse(extrasJsonEl.textContent) : null;
            let matchingVariant = null;

            if (extrasData?.variants) {
              console.log('Available variants:', extrasData.variants.map(v => ({ id: v.id, title: v.title })));
              
              matchingVariant = extrasData.variants.find(v => {
                const tl = v.title.toLowerCase();

                const engravingIsOne = engraving === 'oneSide';
                const engravingIsTwo = engraving === 'twoSides';
                const engravingIsNone = engraving === 'none';
                const giftZero = hasGift && giftPrice === 0;
                const giftNo = !hasGift;
                const giftAmt25 = hasGift && giftPrice === 25;
                const giftAmt50 = hasGift && giftPrice === 50;

                // engraving‑only, no gift wrap
                if (giftNo && engravingIsOne && tl.includes('one side engraving') && !tl.includes('wrap') && !tl.includes('gift wrap')) {
                  console.log('Matched: Engraving only (one side) -', v.title);
                  return true;
                }
                if (giftNo && engravingIsTwo && tl.includes('two sides engraving') && !tl.includes('wrap') && !tl.includes('gift wrap')) {
                  console.log('Matched: Engraving only (two sides) -', v.title);
                  return true;
                }

                // no extras case (free wrap complementory etc)
                if (giftNo && engravingIsNone && tl.includes('complementory') && tl.includes('wrap') && !tl.includes('with')) {
                  console.log('Matched: No extras -', v.title);
                  return true;
                }

                // free gift wrap only
                if (giftZero && engravingIsNone && tl.includes('complementory') && !tl.includes('with') && tl.includes('wrap')) {
                  console.log('Matched: Free gift wrap only -', v.title);
                  return true;
                }

                // free wrap + engraving
                if (giftZero && engravingIsOne && tl.includes('complementory') && tl.includes('one side engraving')) {
                  console.log('Matched: Free wrap + one side engraving -', v.title);
                  return true;
                }
                if (giftZero && engravingIsTwo && tl.includes('complementory') && tl.includes('two sides engraving')) {
                  console.log('Matched: Free wrap + two sides engraving -', v.title);
                  return true;
                }

                // paid wrap (25) - gift only (no engraving)
                // More flexible matching: check for gift wrap 25 and ensure no engraving mention
                if (giftAmt25 && engravingIsNone) {
                  const hasGiftWrap25 = (tl.includes('gift wrap(25)') || tl.includes('gift wrap (25)') || tl.includes('giftwrap(25)') || (tl.includes('25') && tl.includes('gift')));
                  const hasNoEngraving = !tl.includes('engraving') && !tl.includes('one side') && !tl.includes('two sides');
                  // Allow 'with' if it's part of the gift wrap description itself
                  if (hasGiftWrap25 && hasNoEngraving) {
                    console.log('Matched: Paid gift wrap $25 only -', v.title);
                    return true;
                  }
                }
                
                // paid wrap (25) + engraving
                if (giftAmt25 && engravingIsOne && tl.includes('gift wrap(25)') && tl.includes('one side engraving')) {
                  console.log('Matched: Gift wrap $25 + one side engraving -', v.title);
                  return true;
                }
                if (giftAmt25 && engravingIsTwo && tl.includes('gift wrap(25)') && tl.includes('two sides engraving')) {
                  console.log('Matched: Gift wrap $25 + two sides engraving -', v.title);
                  return true;
                }

                // paid wrap (50) - gift only (no engraving)
                // More flexible matching: check for gift wrap 50 and ensure no engraving mention
                if (giftAmt50 && engravingIsNone) {
                  const hasGiftWrap50 = (tl.includes('gift wrap(50)') || tl.includes('gift wrap (50)') || tl.includes('giftwrap(50)') || (tl.includes('50') && tl.includes('gift')));
                  const hasNoEngraving = !tl.includes('engraving') && !tl.includes('one side') && !tl.includes('two sides');
                  // Allow 'with' if it's part of the gift wrap description itself
                  if (hasGiftWrap50 && hasNoEngraving) {
                    console.log('Matched: Paid gift wrap $50 only -', v.title);
                    return true;
                  }
                }
                
                // paid wrap (50) + engraving
                if (giftAmt50 && engravingIsOne && tl.includes('gift wrap(50)') && tl.includes('one side engraving')) {
                  console.log('Matched: Gift wrap $50 + one side engraving -', v.title);
                  return true;
                }
                if (giftAmt50 && engravingIsTwo && tl.includes('gift wrap(50)') && tl.includes('two sides engraving')) {
                  console.log('Matched: Gift wrap $50 + two sides engraving -', v.title);
                  return true;
                }

                return false;
              });
            }

            console.log('Matching variant object:', matchingVariant);
            if (!matchingVariant && hasGift) {
              console.warn('No matching variant found for gift option. Gift state:', { hasGift, giftPrice, engraving });
            }

            // CRITICAL: If no gift selected (option 0) and no engraving, don't add any addon variant
            if (!hasGift && engraving === 'none') {
              console.log('No gift and no engraving selected - skipping addon variant');
              return { description: 'No extras selected', variant: null };
            }

            // If a matching variant found, add to cart
            if (matchingVariant) {
              const addonVariantId = matchingVariant.id;
              const parentId = this.variantIdInput.value;

              // CRITICAL: Ensure we have a valid reference before adding addon
              if (!reference || reference.trim() === '') {
                console.error('Cannot add addon: reference ID is missing!');
                return { description: 'Error: Missing reference ID', variant: null };
              }

              try {
                const res = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    items: [
                      {
                        id: addonVariantId,
                        quantity: 1,
                        properties: {
                          "__ReferenceItem": reference,
                          "_MainProductVariantId": parentId, // Additional identifier for extra safety
                          "_AddonType": hasGift ? 'gift' : (engraving === 'oneSide' ? 'engraving_one' : 'engraving_two')
                        }
                      }
                    ]
                  })
                });
                
                if (!res.ok) {
                  throw new Error(`Addon add failed: ${res.status} ${res.statusText}`);
                }
                
                const data = await res.json();
                console.log('Addon added successfully with reference linking:', {
                  addonVariantId,
                  reference,
                  parentId,
                  properties: { __ReferenceItem: reference }
                });
              } catch (err) {
                console.error('Error adding addon with parent property:', err);
                throw err; // Re-throw to prevent form submission if addon fails
              }
            }

            // Return object always with these keys
            return { description, variant: matchingVariant || null };

          } catch (error) {
            console.error('Error in detectAndHandleExtras:', error);
            return { description: 'Error', variant: null };
          }
        }
        async onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          try {
            // Ensure all necessary inputs are enabled before submission
            // Shopify FormData doesn't include disabled inputs
            const giftInput = this.form.querySelector('.product-variant-message');
            const referenceInput = this.form.querySelector('.product-reference');
            const engravingPromptInput = this.form.querySelector('.product-eng_prompt');
            const singleSideInput = this.form.querySelector('.product-single_side');
            const doubleSideInput = this.form.querySelector('.product-double_side');
            const finalMessageInput = this.form.querySelector('.product-final_message');
            
            // Sync gift message textarea to hidden input before enabling
            const giftBoxNoteTextarea = document.querySelector('#product-giftwrap-message');
            if (giftInput && giftBoxNoteTextarea) {
              // Sync the textarea value if it exists
              const messageText = giftBoxNoteTextarea.value.trim();
              if (messageText) {
                // Store message in data attribute for later use
                giftInput.setAttribute('data-gift-message', messageText);
              }
            }
            
            // CRITICAL: Generate a NEW unique reference ID for EACH form submission
            // This ensures each product instance gets its own unique reference when submitting without page reload
            if (referenceInput) {
              // Always generate a new reference ID for each submission to ensure uniqueness
              // This is critical for multiple submissions without page reload
              const uniqueRef = `ref_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
              referenceInput.value = uniqueRef;
              console.log('Generated NEW reference ID for main product:', uniqueRef);
              // Always enable reference input so it's included in FormData
              referenceInput.disabled = false;
            }
            
            // Temporarily enable inputs if they have values (for FormData inclusion)
            if (giftInput && giftInput.value && giftInput.value !== '') {
              giftInput.disabled = false;
            }
            if (engravingPromptInput && engravingPromptInput.value) {
              engravingPromptInput.disabled = false;
            }
            if (singleSideInput && singleSideInput.value) {
              singleSideInput.disabled = false;
            }
            if (doubleSideInput && doubleSideInput.value) {
              doubleSideInput.disabled = false;
            }
            if (finalMessageInput && finalMessageInput.value) {
              finalMessageInput.disabled = false;
            }
            
            // 1. Await the add‑on detection/handling
            const { description, variant } = await this.detectAndHandleExtras();
            // 2. Proceed with main form submission
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            
            // Include gift message text if available
            const giftBoxNote = document.querySelector('#product-giftwrap-message');
            const giftMessageInput = this.form.querySelector('.product-variant-message');
            if (giftMessageInput && giftMessageInput.value && giftBoxNote && giftBoxNote.value.trim()) {
              // Get the property name from the gift message input
              const propertyName = giftMessageInput.getAttribute('name') || 'properties[Message]';
              // Extract the base name without 'properties[' and ']'
              let baseName = propertyName.replace(/^properties\[/, '').replace(/\]$/, '');
              // Add the actual message text as a separate property
              formData.append(`properties[${baseName} - Message]`, giftBoxNote.value.trim());
            }
            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map(section => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }

            config.body = formData;
            const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', 'true');
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // 3. Update cart contents
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              await publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            }
            this.error = false;

            // CRITICAL: Reset reference ID after successful submission
            // This ensures the next submission (without page reload) gets a new unique reference
            const referenceInputAfterSubmit = this.form.querySelector('.product-reference');
            if (referenceInputAfterSubmit) {
              // Clear the reference so next submission generates a new one
              referenceInputAfterSubmit.value = '';
              referenceInputAfterSubmit.disabled = true;
              console.log('Reset reference ID after successful submission - ready for next submission');
            }

            // ============================================
            // COMPLETE RESET AFTER FORM SUBMISSION
            // ============================================
            
            // 1. Reset gift dropdown to default (empty/disabled state)
            const giftwrapSelect = document.getElementById('product-giftwrap-options');
            if (giftwrapSelect) {
              giftwrapSelect.value = '';
              // Trigger change event to update UI (hide gift message box, update validation)
              giftwrapSelect.dispatchEvent(new Event('change', { bubbles: true }));
              console.log('Reset gift dropdown to default state');
            }

            // 2. Clear gift message textarea and hide error message
            const giftMessageTextarea = document.querySelector('#product-giftwrap-message');
            if (giftMessageTextarea) {
              giftMessageTextarea.value = '';
              // Hide any error message
              const giftBoxContainer = giftMessageTextarea.closest('.product-giftwrap-inner') || giftMessageTextarea.parentElement;
              if (giftBoxContainer) {
                const errorMessageEl = giftBoxContainer.querySelector('.gift-message-error');
                if (errorMessageEl) {
                  errorMessageEl.style.display = 'none';
                }
              }
              console.log('Cleared gift message textarea and error message');
            }

            // 3. Clear all hidden gift-related inputs
            if (giftInput) {
              giftInput.value = '';
              giftInput.setAttribute('disabled', 'disabled');
              giftInput.disabled = true;
              giftInput.removeAttribute('data-gift-message');
            }

            // 4. Clear engraving popup text fields
            const side1Inputs = document.querySelectorAll('.side1_inputs .engrave_line');
            const side2Inputs = document.querySelectorAll('.side2_inputs .engrave_line');
            [...side1Inputs, ...side2Inputs].forEach(input => {
              input.value = '';
              // Reset character count display
              const charCountEl = input.parentElement?.querySelector('.character-count .char-count');
              if (charCountEl) {
                charCountEl.textContent = '0';
                const characterCountContainer = input.parentElement?.querySelector('.character-count');
                if (characterCountContainer) {
                  characterCountContainer.style.color = '#666';
                }
              }
            });

            // 5. Reset font selector to default (first option)
            const fontSelector = document.querySelector('.custom-font-select');
            const fontOptions = fontSelector?.querySelector('.options');
            const fontSelected = fontSelector?.querySelector('.selected');
            if (fontOptions && fontSelected) {
              const firstOption = fontOptions.querySelector('div[data-font]');
              if (firstOption && fontSelected) {
                const font = firstOption.getAttribute('data-font');
                const style = firstOption.style.fontStyle || 'normal';
                fontSelected.textContent = firstOption.textContent.trim();
                fontSelected.style.fontFamily = firstOption.style.fontFamily;
                fontSelected.style.fontStyle = style;
                // Apply font to inputs
                [...side1Inputs, ...side2Inputs].forEach(input => {
                  input.style.fontFamily = firstOption.style.fontFamily;
                  input.style.fontStyle = style;
                });
              }
            }

            // 6. Clear display previews
            const display1 = document.getElementById('display_text1');
            const display2 = document.getElementById('display_text2');
            if (display1) {
              display1.innerHTML = '<span>Enter The Text To Engrave</span>';
            }
            if (display2) {
              display2.innerHTML = '<span>Enter The Text To Engrave</span>';
            }

            // 7. Reset engraving popup to step 1 (always, even if closed)
            const engravingPopup = document.querySelector('.engraving_popup--wrapper');
            if (engravingPopup) {
              const btnPrev = engravingPopup.querySelector('.popup_prev');
              const btnSave = engravingPopup.querySelector('.popup_save');
              const btnNext = engravingPopup.querySelector('.popup_next');
              const engraveView = engravingPopup.querySelector('.engrave_view--area');
              const engraveFonts = engravingPopup.querySelector('.faces_wrapper_main');

              // Always reset to step 1
              if (btnPrev) btnPrev.classList.add('hidden');
              if (btnSave) btnSave.classList.add('hidden');
              if (engraveView) engraveView.classList.add('hidden');
              if (btnNext) btnNext.classList.remove('hidden');
              if (engraveFonts) engraveFonts.classList.remove('hidden');
              engravingPopup.classList.remove('stepActive');
              engravingPopup.classList.add('hidden');
              console.log('Reset engraving popup to step 1');
            }

            // 8. Clear all hidden engraving inputs
            if (singleSideInput) {
              singleSideInput.value = '';
              singleSideInput.setAttribute('disabled', 'disabled');
              singleSideInput.disabled = true;
              singleSideInput.removeAttribute('data-engraving-cost');
            }
            if (doubleSideInput) {
              doubleSideInput.value = '';
              doubleSideInput.setAttribute('disabled', 'disabled');
              doubleSideInput.disabled = true;
              doubleSideInput.removeAttribute('data-engraving-cost');
            }
            if (engravingPromptInput) {
              engravingPromptInput.value = '';
              engravingPromptInput.setAttribute('disabled', 'disabled');
              engravingPromptInput.disabled = true;
            }
            if (finalMessageInput) {
              finalMessageInput.value = '';
              finalMessageInput.setAttribute('disabled', 'disabled');
              finalMessageInput.disabled = true;
            }

            // 9. Clear sessionStorage for engraving popup values
            try {
              sessionStorage.removeItem('engravingPopupValues');
              sessionStorage.removeItem('engravingData');
            } catch (e) {
              console.warn('Could not clear sessionStorage:', e);
            }

            // 10. Update prices after clearing everything
            // Wait a moment for change event to process, then update prices
            setTimeout(() => {
              const priceWrapper = document.querySelector('.dynaimc_prices--wrapper');
              if (priceWrapper) {
                // Hide price wrapper since all extras are cleared
                priceWrapper.classList.add('hidden');
                
                // Update price displays to show $0.00 or empty
                const extrasPricesElems = document.querySelectorAll('.extras_prices');
                extrasPricesElems.forEach(el => {
                  const isExtras = el.hasAttribute('data-gift_addon') && el.hasAttribute('data-engraving_addon')
                                   && !el.hasAttribute('data-product_price');
                  const isTotal = el.hasAttribute('data-product_price') && el.hasAttribute('data-gift_addon')
                                  && el.hasAttribute('data-engraving_addon');

                  if (isExtras) {
                    // Clear extras price display
                    el.textContent = '';
                    el.setAttribute('data-gift_addon', '');
                    el.setAttribute('data-engraving_addon', '');
                  }

                  if (isTotal) {
                    // Update total to show only product price (no extras)
                    const productPriceAttr = el.getAttribute('data-product_price') || '';
                    const productPriceText = productPriceAttr.replace(/[^0-9.]/g, '');
                    const base = parseFloat(productPriceText) || 0;
                    el.textContent = `$${base.toFixed(2)}`;
                    el.setAttribute('data-gift_addon', '');
                    el.setAttribute('data-engraving_addon', '');
                  }
                });
                
                console.log('Updated prices after clearing all fields');
              }
            }, 50);

            // 11. Re-enable submit button (in case it was disabled for gift message validation)
            if (this.submitButton) {
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.disabled = false;
            }

            console.log('✅ Complete reset after form submission - all fields cleared and prices updated');

           

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          } catch (e) {
            console.error('Submission error:', e);
          } finally {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          }
        }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
             if (giftMessageInput) {
        giftMessageInput.setAttribute('disabled', 'disabled');
        giftMessageInput.value = '';
      }
      // Disable and clear personalized inputs
      if (singleSideInput) {
        singleSideInput.setAttribute('disabled', 'disabled');
        singleSideInput.value = '';
      }
      if (doubleSideInput) {
        doubleSideInput.setAttribute('disabled', 'disabled');
        doubleSideInput.value = '';
      }
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
